/* ============================================================
   SOCIAL IRONY — collection.js
   Sort + filter UX. Filtering itself is a native form GET, so it works
   without JS and stays crawlable. This only adds the mobile panel toggle
   and auto-submit for the sort dropdown.
   ============================================================ */

(function () {
  'use strict';

  const qs = window.SI.qs;

  /* ---------- Mobile filter panel ---------- */
  const toggle = qs('[data-si-filter-toggle]');
  const panel = qs('[data-si-filters]');

  if (toggle && panel) {
    toggle.addEventListener('click', () => {
      const isOpen = panel.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  /* ---------- Sort: submit on change ---------- */
  const sortSelect = qs('[data-si-sort]');
  if (sortSelect) {
    sortSelect.addEventListener('change', () => {
      const form = sortSelect.closest('form');
      if (form) form.submit();
    });
  }

  /* ---------- Filter form: auto-submit checkboxes ---------- */
  const filterForm = qs('[data-si-filter-form]');
  if (filterForm) {
    filterForm.addEventListener('change', (event) => {
      if (event.target.matches('input[type="checkbox"]')) {
        filterForm.submit();
      }
    });
  }
})();
